import { render, staticRenderFns } from "./Repay.vue?vue&type=template&id=4b5a3e97&scoped=true&"
import script from "./Repay.vue?vue&type=script&lang=js&"
export * from "./Repay.vue?vue&type=script&lang=js&"
import style0 from "./Repay.vue?vue&type=style&index=0&id=4b5a3e97&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a3e97",
  null
  
)

export default component.exports